import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '1',
    title: 'Prepare',
    description: 'Use the Activity Menu to set up "Low-Dopamine" stations on Friday night.'
  }, {
    number: '2',
    title: 'Execute',
    description: 'Follow the Day 1 and Day 2 hour-by-hour scripts to manage the "Extinction Burst" (peak tantrum).'
  }, {
    number: '3',
    title: 'Transition',
    description: 'Use the Sustainable Rules on Monday to keep the peace forever.'
  }];
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background)'
  }} data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-4 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-53">
          How It Works
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="text-center text-lg mb-12 opacity-70" style={{
        color: 'var(--color-text)'
      }} data-id="element-54">
          A simple 3-step process over one weekend.
        </motion.p>

        <div className="space-y-0" data-id="element-55">
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.15 + index * 0.1
        }} className="relative flex gap-6 pb-12 last:pb-0" data-id="element-56">
              {/* Vertical line */}
              {index < steps.length - 1 && <div className="absolute left-6 top-14 w-0.5 h-[calc(100%-3.5rem)]" style={{
            backgroundColor: 'var(--color-border)'
          }} data-id="element-57" />}

              {/* Number circle */}
              <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 text-xl font-bold text-white" style={{
            backgroundColor: 'var(--color-accent)'
          }} data-id="element-58">
                {step.number}
              </div>

              {/* Content */}
              <div className="pt-2" data-id="element-59">
                <h3 className="text-2xl font-semibold mb-2" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-text)'
            }} data-id="element-60">
                  {step.title}
                </h3>
                <p className="text-lg" style={{
              color: 'var(--color-text)',
              opacity: 0.8
            }} data-id="element-61">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}